var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"identifier-filters"},[_c('div',{staticClass:"identifier-filters-text"},[_vm._v(_vm._s(_vm.text))]),(_vm.action)?_c('span',{staticClass:"material-icons identifier-filters-icon",on:{"click":function($event){return _vm.action()}}},[_vm._v("close")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }